import { CartState } from '../Reducers/Cart.reducer';
import { Order } from '../Types/Order';
import { OrderRow } from '../Types/OrderRow';

const pintrk = (key: string, ev: string, data: any = undefined) =>
  typeof window['pintrk'] === 'function'
    ? window['pintrk'](key, ev, data)
    : undefined;

interface PinterestAddToCartData {
  quantity: number;
  price: number;
  currency: string;
}

export const pinterestServiceAddToCartEvent = ({
  quantity,
  price,
  currency,
}: PinterestAddToCartData) => {
  if(global.PinterestPixelId){
    pintrk('track', 'addtocart', {
      order_quantity: quantity,
      value: price,
      currency: currency,
    });
  }
};

export const pinterestServiceInitiateCheckoutEvent = (cart: CartState) => {
  if (cart) {
    if(global.PinterestPixelId){
      pintrk('track', 'custom', {
        event_id: 'initiateCheckout',
        value: cart.total,
        currency: cart.currency ?? '',
        line_items: getMappedOrderRows(cart?.orderRows),
      });
    }
  }
};

export const pinterestServicePurchaseEvent = (order: Order) => {
  if(global.PinterestPixelId){
    pintrk('track', 'checkout', {
      event_id: 'checkout',
      currency: order.currency,
      order_id: order.externalOrderID,
      order_quantity: order.orderRows.length,
      value: order.grandTotalValue,
      line_items: getMappedOrderRows(order.orderRows),
    });
  }
};

export const pinterestServiceNewsLetterEvent = () => {
  if(global.PinterestPixelId){
    pintrk('track', 'Lead', {
      lead_type: 'Newsletter',
    });
  }
};

export const pinterestServiceSearchEvent = (query: string) => {
  if(global.PinterestPixelId){
    pintrk('track', 'Search', {
      search_query: query,
    });
  }
};

const getMappedOrderRows = (rows: OrderRow[]) => {
  const result: MappedOrderRow[] = [];
  rows?.map((row) => {
    result.push({
      product_name: row.name,
      product_id: row.articleNumber,
      product_price: (row.priceInfo?.campaignPrice ?? row.priceInfo?.price)
        ?.price,
      product_quantity: row.quantity,
      product_category:
        row.gtmEcommerceItem?.item_category ?? row.categoryName ?? '',
    });
  });

  return result;
};

interface MappedOrderRow {
  product_name: string;
  product_id: string;
  product_price?: number;
  product_quantity: number;
  product_category: string;
}
